export enum ReportingPeriodFilter {
  PREVIOUS_MONTH = 'previousMonth',
  PAST_3_MONTHS = 'past3Months',
  YEAR_TO_DATE = 'yearToDate',
  PAST_12_MONTHS = 'past12Months',
  LAST_CALENDAR_YEAR = 'lastCalendarYear',
}

// Component-facing trend type
export type Trend = 'INCREASING' | 'DECREASING' | 'NEUTRAL';

// API trend type from OpenAPI schema
export type ApiTrend = 'UP' | 'DOWN' | 'NEUTRAL' | 'FLAT' | 'UNKNOWN';

export interface TrendMetricValue {
  trend: Trend | null;
  value: number;
}

export interface InsightMetricsResponse {
  totalCompletions: TrendMetricValue;
  totalHoursCompleted: TrendMetricValue;
  nonCompliantUsers: TrendMetricValue;
  credentialsToExpire: TrendMetricValue;
}

// Legacy interface for backward compatibility
export interface TrendMetric {
  id: string;
  name: string;
  trend: Trend;
  value: number;
}

export interface CompliantUsers {
  compliant: number;
  nonCompliant: number;
  total: number;
}

export interface CredentialExpireRecord {
  date: string;
  totalCredentials: number;
}

export interface CredentialsExpiringSeries {
  series: CredentialExpireRecord[];
}

// API Response Types (matching OpenAPI schema)
export interface TrainingInsightsCenterComplianceSummaryResponseTotalCompletions {
  trend: ApiTrend;
  value: number;
}

export interface TrainingInsightsCenterComplianceSummaryResponse {
  totalCompletions: TrainingInsightsCenterComplianceSummaryResponseTotalCompletions;
  totalHoursCompleted: TrainingInsightsCenterComplianceSummaryResponseTotalCompletions;
  nonCompliantUsers: TrainingInsightsCenterComplianceSummaryResponseTotalCompletions;
  credentialsToExpire: TrainingInsightsCenterComplianceSummaryResponseTotalCompletions;
}

export interface TrainingCredentialsExpiringMetricsResponseItem {
  date: string; // ISO date-time format
  totalCredentials: number;
}

export type TrainingCredentialsExpiringMetricsResponse = TrainingCredentialsExpiringMetricsResponseItem[];

// API Response Type for compliant vs non-compliant metrics
export interface CompliantVsNonCompliantMetricsResponse {
  compliant: number;
  nonCompliant: number;
  total: number;
}

// Helper function to map API trend values to component trend values
export function mapApiTrendToTrend(apiTrend: ApiTrend): Trend | null {
  switch (apiTrend) {
    case 'UP':
      return 'INCREASING';
    case 'DOWN':
      return 'DECREASING';
    case 'FLAT':
    case 'NEUTRAL':
    case 'UNKNOWN':
      return 'NEUTRAL';
    default:
      return null;
  }
}
